import { useWatch } from 'react-hook-form';
import { AceTextField, AceTextFieldProps } from './AceTextField';
import { useEmailValidationService } from '../../hooks/queries/useEmailValidationService';

type AceEmailFieldProps<T extends object, V> = AceTextFieldProps<T, V>;

export function AceEmailField<T extends object, V>({
  control,
  name,
  warning,
  ...rest
}: AceEmailFieldProps<T, V>) {
  const email = useWatch({ control, name });
  const isValid = useEmailValidationService({
    email: email ? String(email) : undefined,
  });

  const validationWarning = !isValid
    ? 'Potentially a fraud/risky email'
    : undefined;
  const fusedWarning =
    warning && validationWarning ? (
      <>
        {warning}
        <br />
        {validationWarning}
      </>
    ) : (
      warning ?? validationWarning
    );

  return (
    <AceTextField
      control={control}
      name={name}
      warning={fusedWarning}
      {...rest}
    />
  );
}
